import 'jquery';
import 'popper.js';
import 'bootstrap';
import 'cleave.js';
import 'cleave.js/src/addons/phone-type-formatter.us';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';


// main nav menu on mobile view - BEGIN
var $menuPrimary = $("#menu-primary"),
    $menuToggle = $(".responsive-menu-toggle");

$menuToggle.click(function () {
    $menuPrimary.slideToggle();
});

$(".responsive-menu > .menu-item").click(function (event) {
    if (event.target !== this)
        return;
    $(this).find(".sub-menu:first").slideToggle(function () {
        $(this).parent().toggleClass("menu-open");
    });
});

$(window).resize(function () {
    if (window.innerWidth > 992) {
        $(".genesis-nav-menu, .genesis-nav-menu .sub-menu").removeAttr("style");
        $(".responsive-menu > .menu-item").removeClass("menu-open");
    }
});

$("#btnIconSearch").click(function () {
    $(".sub-header .search-wrapper").toggleClass("expanded");
});

$("body").scrollspy({ target: "#navbar", offset: 70 });

/* When user clicks a link, collapse the menu for xs screens. */
$(".navbar-nav li a").click(function () {
    if ($(window).width() < 768) {
        $(".navbar-toggle").click();
    }
});

// main nav menu on mobile view - END

// collapse support

function getFormControlValue($element) {
    var value = $element.val()

    if (!$element.is(':checkbox, :radio, select')) {
        return value
    }

    if ($element.is(':checked, :selected')) {
        return value
    }
}

$("[data-collapse]").each(function () {
    var $element = $(this);
    var $target = $($element.data("collapse"))
    var $targetInputs = $target.find(":input")
    var value = $element.data("collapse-value") || "True"

    //determine if we should show the div by default
    if (getFormControlValue($element) === value) {
        $target.show()
    }

    $element.on("click", function () {
        if (getFormControlValue($element) === value) {
            $target.show()
        } else {
            $target.hide()

            //clear all form controls within the hidden wrapper
            $targetInputs.removeAttr('checked')
                .removeAttr('selected')
                .not(':checkbox, :radio, select')
                .val('')
            $targetInputs.trigger("input")
        }
    })
})

// cleave text formatting
$('[type=tel]').toArray().forEach(function (phoneField) {
    var cleave = new Cleave(phoneField, {
        phone: true,
        phoneRegionCode: 'us'
    });
});

if ($('.card-expiration').length > 0) {
    var cleave = new Cleave('.card-expiration', {
        date: true,
        datePattern: ['m', 'y']
    });
}

if ($.validator && $.validator.unobtrusive) {

    $.validator.unobtrusive.adapters.add("requirediftrue",
        ["property", "value"],
        function (options) {
            var params = {
                property: "[id$='" + options.params["property"] + "']:first",
                value: options.params["value"]
            };
            options.rules['requirediftrue'] = params;

            if (options.message) {
                options.messages["requirediftrue"] = options.message;
            }
        }
    );
    $.validator.addMethod("requirediftrue", function (value, element, params) {
        var required = true;
        var propertyValue = $(params.property).val();

        if (propertyValue == params.value) {
            required = value !== "" && value != null;
        }

        return required;
    });

    $.validator.unobtrusive.adapters.add("requirediffalse",
        ["property", "value"],
        function (options) {
            var params = {
                property: "#" + options.params["property"],
                value: options.params["value"]
            };
            options.rules['requirediffalse'] = params;

            if (options.message) {
                options.messages["requirediffalse"] = options.message;
            }
        }
    );
    $.validator.addMethod("requirediffalse", function (value, element, params) {
        var required = true;
        var propertyValue = $(params.property).val();

        if (propertyValue != params.value) {
            required = value !== "" && value != null;
        }

        return required;
    });
}

$(function () {
    $.each($('input[maxlength][data-val-maxlength]'), function (idx, el) {
        $(el).removeAttr('maxlength');
    });
});

